import React, { Component } from "react";
import {
  Container,
  Grid,
  Header,
  Icon,
  Segment,
  Menu,
  Breadcrumb,
} from "semantic-ui-react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { translate } from "react-i18next";
import RecoveryForm from "../forms/RecoverForm";
import AuthManagement from "feathers-authentication-management/lib/client";

const styles = {
  container: {
    paddingTop: 0,
    paddingBottom: 32,
  },
};

class RecoverPasswordView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      accountNumber: "",
      email: "",
      loading: false,
      error: null,
      message: null,
    };

    this.FeathersService = this.props.services.feathers;
    this.AuthManager = AuthManagement(this.FeathersService);
  }

  createInputHandler(name) {
    return (e, input) => {
      this.setState({
        [name]: e.target.value,
      });
    };
  }

  submitRecoveryRequest() {
    this.setState({
      loading: true,
    });
    const {
      email, // eslint-disable-next-line
      accountNumber,
    } = this.state;
    this.AuthManager.sendResetPwd({ email })
      .then((result) => {
        console.log("result", result);
        this.setState({
          loading: false,
          message: "recover.success",
          error: null,
        });
      })
      .catch((error) => {
        this.setState({
          error,
          loading: false,
          message: null,
        });
      });
  }

  static mapStateToProps(state) {
    return {
      routing: state.routing,
      authentication: state.authentication,
    };
  }

  static mapDispatchToProps(dispatch) {
    return {
      navigate: (path) => dispatch(push(path)),
    };
  }

  render() {
    let { accountNumber, email, loading, error, message } = this.state;
    let recoveryProps = { accountNumber, email, loading, error, message };
    let { t } = this.props;

    return (
      <Container style={styles.container}>
        <Menu
          inverted
          style={{ backgroundColor: "#136444", borderRadius: 0, margin: 0 }}
        >
          <Menu.Item name="inicio" active={true} />
          <Menu.Item name="nosotros" active={false} />
        </Menu>

        <Segment vertical secondary style={{ padding: 4 }}>
          <Breadcrumb>
            <Breadcrumb.Section as={Link} link to={"/"}>
              Inicio
            </Breadcrumb.Section>
            <Breadcrumb.Divider icon="right angle" />
            <Breadcrumb.Section active>Ingreso</Breadcrumb.Section>
          </Breadcrumb>
        </Segment>

        <Segment vertical>
          <Header as="h3">
            <Header.Content>
              INGRESAR
              <Header.Subheader>Acceso al sistema</Header.Subheader>
            </Header.Content>
          </Header>
        </Segment>

        <Grid columns={1} centered doubling style={{ marginTop: 30 }}>
          <Grid.Row>
            <Grid.Column widescreen={6} mobile={16} tablet={10} computer={8}>
              <Segment attached="top" textAlign="center">
                <Header as="h2" icon>
                  <Icon name="key" />
                  {t("recover.title")}
                  <Header.Subheader>{t("recover.subtitle")}</Header.Subheader>
                </Header>
              </Segment>
              <Segment attached>
                <RecoveryForm
                  {...recoveryProps}
                  createInputHandler={this.createInputHandler.bind(this)}
                  onSubmit={this.submitRecoveryRequest.bind(this)}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}
const i18nEnhancement = translate("translations")(RecoverPasswordView);

export default connect(
  RecoverPasswordView.mapStateToProps,
  RecoverPasswordView.mapDispatchToProps
)(i18nEnhancement);



// WEBPACK FOOTER //
// ./src/components/views/RecoverPasswordView.jsx